import { MapPin, Eye, Video } from "lucide-react";

export default function UpcomingTable({ data, onView, onJoinMeeting }) {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl overflow-x-auto">
      <table className="w-full text-sm min-w-[860px]">
        <thead>
          <tr className="border-b border-gray-100 text-left text-xs font-semibold text-gray-400 tracking-wide">
            <th className="px-6 py-4">NAME</th>
            <th className="px-6 py-4">DATE & TIME</th>
            <th className="px-6 py-4">LOCATION</th>
            <th className="px-6 py-4">EMAIL</th>
            <th className="px-6 py-4">MOBILE</th>
            <th className="px-6 py-4">MEETING</th>
            <th className="px-6 py-4 text-right">ACTION</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id} className="border-b border-gray-50 last:border-none">
              <td className="px-6 py-4">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-xs font-bold flex items-center justify-center shrink-0">
                    {row.initials}
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">{row.name}</p>
                    <p className="text-xs text-gray-500">{row.specialty}</p>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4">
                <p className="text-gray-900">{row.date}</p>
                <p className="text-xs text-gray-500">{row.time}</p>
              </td>
              <td className="px-6 py-4">
                <span className="flex items-center gap-1.5 text-gray-700">
                  <MapPin className="w-3.5 h-3.5" /> {row.location}
                </span>
              </td>
              <td className="px-6 py-4 text-gray-700">{row.email}</td>
              <td className="px-6 py-4 text-gray-700">{row.mobile}</td>
              <td className="px-6 py-4">
                <button
                  onClick={() => onJoinMeeting(row)}
                  className="inline-flex items-center gap-1.5 text-sm font-semibold bg-green-600 text-white px-4 py-1.5 rounded-lg hover:bg-green-700 transition"
                >
                  <Video className="w-3.5 h-3.5" /> Join Meeting
                </button>
              </td>
              <td className="px-6 py-4 text-right">
                <button
                  onClick={() => onView(row)}
                  className="inline-flex items-center gap-1.5 text-sm font-semibold border border-gray-200 px-4 py-1.5 rounded-lg hover:bg-gray-50 transition"
                >
                  <Eye className="w-3.5 h-3.5" /> View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}